import { render, staticRenderFns } from "./StudentIndexManage.vue?vue&type=template&id=63df4f86"
import script from "./StudentIndexManage.vue?vue&type=script&lang=js"
export * from "./StudentIndexManage.vue?vue&type=script&lang=js"
import style0 from "./StudentIndexManage.vue?vue&type=style&index=0&id=63df4f86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports